class Financas
{
    constructor(descricao,valor,tipoValor)
    {
        this.descricao = descricao;
        this.valor = valor;
        this.tipoValor = tipoValor
    }
}
export default Financas